<ui-icon-button [title]="'Download'" [iconName]="'icon-xml'" [heightInPx]="'27'" [widthInPx]="'20'"  (click)="viewXML()"></ui-icon-button>